module.exports = __webpack_public_path__ + "static/ifat.36df1224.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ui/ifat.png
// module id = 513
// module chunks = 263791100135453